import { FC } from 'react';
import { LayoutCarousel } from '@silverfort/sf-components';
import { MfaResponse, MfaResponseType } from '../../types';
import { useMfaResponseData } from './hooks/useMfaResponseData';
import usePaginatedDonutChart from '../../hooks/usePaginatedDonutChart';

interface MfaResponseChartProps {
    mfaResponse?: MfaResponse;
    isLoading: boolean;
    className?: string;
    onClick: (mfaResponse: MfaResponseType) => void;
    innerCircleEmptyStateClassName?: string;
}

const MfaResponseChart: FC<MfaResponseChartProps> = ({ mfaResponse, isLoading, className, onClick, innerCircleEmptyStateClassName = '' }) => {
    const chartData = useMfaResponseData(onClick, mfaResponse);
    const pages = usePaginatedDonutChart({ chartData, isLoading, innerCircleEmptyStateClassName });

    return (
        <LayoutCarousel
            title="MFA response"
            className={className}
            contentClassName="flex flex-1 flex-col justify-center px-6 flex-shrink-0 h-full min-h-[150px]"
            pages={pages}
        />
    );
};

export default MfaResponseChart;
